export function getPricePrefix(price: number) {
    if (price === 0) {
        return '';
    }
    return price > 0 ? '+' : '-';
}

export function getFormatedOptionPrice(price: number) {
    if (price === 0) {
        return '';
    }
    const prefix = getPricePrefix(price);
    return `${prefix}${Math.abs(price).toLocaleString()}`;
}
